export const UploadAction = {
	Lock: "lock",
	Unlock: "unlock",
} as const;

export type UploadAction = (typeof UploadAction)[keyof typeof UploadAction];
